import { useRootStore } from '@pinia/index';
import { useSessionStore } from '@pinia/session';

export default () => {
  const root = useRootStore();
  const sessionStore = useSessionStore();

  const executeApiCall: typeof root.cloudService.executeApiCall = (method, requestMessage) => {
    const metadata = new Headers();
    if (sessionStore.token != null) {
      metadata.set('Authorization', `Bearer ${sessionStore.token}`);
    }
    return root.cloudService.executeApiCall(method, requestMessage, metadata, 90 * 1000);
  };

  const subscribeApiCall: typeof root.cloudService.subscribeApiCall = (method, requestMessage) => {
    const metadata = new Headers();
    if (sessionStore.token != null) {
      metadata.set('Authorization', `Bearer ${sessionStore.token}`);
    }
    return root.cloudService.subscribeApiCall(method, requestMessage, metadata);
  };

  return {
    executeApiCall,
    subscribeApiCall,
    client: null,
  };
};
